import { InjectionToken } from '@angular/core';
import type { AdminUserRole } from '@cappus/shared-common';
import type { MenuItem } from './main-menu-config.type';

export const TOP_RIGHT_MENU_CONFIG_TOKEN = new InjectionToken<MenuItem<AdminUserRole>[]>(
  'TOP_RIGHT_MENU_CONFIG_TOKEN',
);
